// @ts-check
import React, { useCallback } from 'react';
import { useTranslation } from '../../localization/useTranslation';
import { Modal, ModalVariant, Flex, FlexItem, FileUpload } from '@patternfly/react-core';
import { confirmButtons } from './ModalButtons';
import { Icons } from 'components/Common';
import { Size } from 'components/Common/Icons';

/**
 * @typedef {Object} UploadFileModalProps
 * @prop {boolean} isOpen
 * @prop {function} onConfirm
 * @prop {() => void} onCancel
 * @prop {string} uploadText
 * @prop {string} confirmText
 * @prop {string} cancelText
 */

/**
 * Shows a confirmation dialog for deleting an item
 * @param {UploadFileModalProps} props
 * @returns {JSX.Element}
 */
const UploadTextFileModal = ({ isOpen, onConfirm, onCancel, uploadText, confirmText, cancelText }) => {
  const T = useTranslation();
  const [value, setValue] = React.useState('');
  const [filename, setFilename] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);

  const handleFileInputChange = (unused, file) => {
    setFilename(file.name);
  };

  const handleDataChange = (_event, value) => {
    setValue(value);
  };

  const handleClear = (_event) => {
    setFilename('');
    setValue('');
  };

  const handleFileReadStarted = (_event) => {
    setIsLoading(true);
  };

  const handleFileReadFinished = (_event) => {
    setIsLoading(false);
  };

  const _onConfirm = useCallback(() => {
    onConfirm(value);
  }, [onConfirm, value]);

  return (
    // @ts-ignore
    <Modal
      variant={ModalVariant.small}
      title={uploadText}
      titleIconVariant={() => <Icons.Upload size={Size.MEDIUM} />}
      isOpen={isOpen}
      onClose={onCancel}
      actions={confirmButtons({ T, onConfirm: _onConfirm, isDisabled: false, confirmText, cancelText, onCancel, isLoading: false })}
    >
      <Flex>
        <FlexItem className="pf-v5-u-w-100">
          <FileUpload
            className="pf-v5-u-w-100"
            id="text-file-simple"
            type="text"
            value={value}
            filename={filename}
            filenamePlaceholder="Drag and drop a file or upload one"
            onFileInputChange={handleFileInputChange}
            onDataChange={handleDataChange}
            onReadStarted={handleFileReadStarted}
            onReadFinished={handleFileReadFinished}
            onClearClick={handleClear}
            isLoading={isLoading}
            browseButtonText="Upload"
          />
        </FlexItem>
      </Flex>
    </Modal>
  );
};

export default React.memo(UploadTextFileModal);
